'use strict';
import isNumber from 'lodash/isNumber';
import {AjaxFactory} from './AjaxFactory';
import {HttpMethod} from './enums';
import {getPageFilterParams} from './utils';


/**
 * @param {ReduxObservableListOptions} options
 */
export function buildPageFactory(options) {
  return new AjaxFactory(buildListRequestOptions(options));
}

/**
 * @param {ReduxObservableListOptions} options
 * @return {AjaxFactoryOptions}
 */
export function buildListRequestOptions(options) {
  return {
    crossDomain: options.crossDomain,
    method: HttpMethod.GET,
    useBody: false,
    url: getListUrl(options),
    getToken: options.getToken,
  };
}

/**
 * @typedef {Object} ListPageRequest
 * @property {String} [parentId]
 * @property {Number} currentPage
 * @property {Number} [pageSize]
 * @property {FilterData} filterData
 */

/**
 * @param {ReduxObservableListOptions} options
 * @return {Function}
 */
export function getListUrl(options) {
  /**
   * @param {ListPageRequest} request
   */
  return function getListUrlCurried(request) {
    return `${options.baseApiUrl}/${getListPath(options, request.parentId)}?${getQueryParams(options, request)}`;
  }
}

/**
 * @param {ReduxObservableListOptions} options
 * @param {ListPageRequest} request
 * @return {String}
 */
export function getQueryParams(options, request) {
  const pageSize = isNumber(request.pageSize) ? request.pageSize : options.pageSize;
  const params = [`page=${request.currentPage}&pageSize=${pageSize}`];

  if (options.listParams) {
    params.push(`&${options.listParams}`);
  }

  const filterParams = getPageFilterParams(options, request);

  if (filterParams) {
    params.push(filterParams);
  }

  return params.join('');
}

function getListPath(options, parentId) {
  if (options.hasParentId) {
    return options.listPath(parentId);
  } else {
    return options.listPath;
  }
}



// WEBPACK FOOTER //
// ./src/js/_libs/redux-observable-list/src/defaultPageFactory.js